// Every route of the application should be defined here

export const ROUTE_PATH = {
  lgv: process.env.REACT_APP_LGV_ONE_URL,
  plantManagement: "/",
  configuration: "/config",
  permissions: "/permissions",
  boundAdjustment: "/bound-adjustment",
};
